/** Shared rack/cadence for ordinary and enhanced throwing stars. */
export const THROWING_STAR_ABILITIES = ['assassin_auto', 'throw_star'] as const;
export const THROWING_STAR_MAGAZINE = 7;
export const THROWING_STAR_RELOAD_MS = 1200;
export const THROWING_STAR_SIZE = 18;
export const THROWING_STAR_READY_MS = 220;
export function isThrowingStarAbility(id: string): boolean {
  return id === 'assassin_auto' || id === 'throw_star';
}
